import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { notBlankValidation, phoneValidation, textLimitValidation } from '../../../utils/validations';
import Input from '../../shared/input/Input';

const ClientForm = ({ onSubmit, initClient = { phone: '+380' }, readOnly, loading }) => {
  const methods = useForm({ defaultValues: initClient });
  return (
    <FormProvider {...methods}>
      <form
        id="client-form"
        noValidate
        className="modal-form"
        onSubmit={methods.handleSubmit((data) => onSubmit(data))}
      >
        <Input
          label="Ім'я"
          type="input"
          name="firstName"
          autoFocus="true"
          disabled={readOnly || loading}
          placeholder={"Введіть ім'я"}
          validation={notBlankValidation}
        />
        <Input
          label="Прізвище"
          type="input"
          name="lastName"
          disabled={readOnly || loading}
          placeholder={'Введіть прізвище'}
          validation={textLimitValidation}
        />
        <Input
          label="Телефон (+380976543210)"
          type="input"
          name="phone"
          disabled={readOnly || loading}
          placeholder={'Введіть телефон'}
          validation={phoneValidation}
        />
      </form>
    </FormProvider>
  );
};

export default ClientForm;
